import Vue from "vue";
import Router from "vue-router";
import utils from "../common/utils";
import store from "../store";


Vue.use(Router);


export const router = new Router({
    base: process.env.BASE_URL,
    mode: process.env.NODE_ENV === "development" ? "hash" : "history",
    routes: [{
        path: '/login',
        name: 'login',
        component: resolve =>
            require(["../views/productBoard/login.vue"], resolve)
    },
    {
        path: '/download',
        name: 'download',
        component: resolve =>
            require(["../views/download.vue"], resolve)
    },
    {
        path: "/",
        component: resolve =>
            require(["../views/schoolBoard/index.vue"], resolve),
        redirect: "/schoolList",
        children: [{
            path: "/boardMain",
            name: "boardMain",
            component: resolve =>
                require(["../views/schoolBoard/boardMain.vue"], resolve)
        },
        {
            path: "/schoolList",
            name: "schoolList",
            component: resolve =>
                require([
                    "../views/productBoard/schoolList.vue"
                ], resolve)
        },
        {
            path: "/conservation_count",
            name: "conservationCount",
            component: resolve =>
                require([
                    "../views/productBoard/conservationCount/conservationCount.vue"
                ], resolve)
        },
        {
            path: "/activeUser_num",
            name: "activeUserNum",
            component: resolve =>
                require([
                    "../views/productBoard/activeUserNum.vue"
                ], resolve)
        },
        {
            path: "/user_conservation_list",
            name: "userConservationList",
            component: resolve =>
                require([
                    "../views/productBoard/conservationCount/userConservationList.vue"
                ], resolve)
        },
        {
            path: "/user_conservation_details",
            name: "userConservationDetails",
            component: resolve =>
                require([
                    "../views/productBoard/conservationCount/userConservationDetails.vue"
                ], resolve)
        },
        {
            path: "/schoolMain",
            name: "schoolMain",
            component: resolve =>
                require(["../views/schoolBoard/schoolMain.vue"], resolve)
        },
        {
            path: "/proBoardMain",
            name: "proBoardMain",
            component: resolve =>
                require([
                    "../views/productBoard/proBoardMain.vue"
                ], resolve)
        },
        {
            path: "/cloudBoardStatic",
            name: "cloudBoardStatic",
            component: resolve =>
                require([
                    "../views/productBoard/cloudBoard/cloudBoardStatic.vue"
                ], resolve)
        },
        {
            path: "/cloudBoardUserList",
            name: "cloudBoardUserList",
            component: resolve =>
                require([
                    "../views/productBoard/cloudBoard/cloudBoardUserList.vue"
                ], resolve)
        },
        {
            path: "/userBoardDetails",
            name: "userBoardDetails",
            component: resolve =>
                require([
                    "../views/productBoard/cloudBoard/userBoardDetails.vue"
                ], resolve)
        },
        {
            path: "/wisdomClassStatic",
            name: "wisdomClassStatic",
            component: resolve =>
                require([
                    "../views/wisdomClass/dataTab/wisdomClassStatic.vue"
                ], resolve)
        },
        {
            path: "/mainModuleDetails",
            name: "mainModuleDetails",
            component: resolve =>
                require([
                    "../views/wisdomClass/dataTab/mainModuleDetails.vue"
                ], resolve)
        },
        {
            path: "/topUseDetails",
            name: "topUseDetails",
            component: resolve =>
                require([
                    "../views/wisdomClass/dataTab/topUseDetails.vue"
                ], resolve)
        },
        {
            path: "/schoolTeacherInfo",
            name: "schoolTeacherInfo",
            component: resolve =>
                require([
                    "../views/wisdomClass/dataTab/schoolTeacherInfo.vue"
                ], resolve)
        },
        {
            path: "/wisdomMain",
            name: "wisdomMain",
            component: resolve =>
                require([
                    "../views/wisdomClass/wisdomMain.vue"
                ], resolve)
        },
        {
            path: "/screenMain",
            name: "screenMain",
            component: resolve =>
                require([
                    "../views/productBoard/screen/screenMain.vue"
                ], resolve)
        },
        {
            path: "/homeworkMain",
            name: "homeworkMain",
            component: resolve =>
                require([
                    "../views/productBoard/homework/homeworkMain.vue"
                ], resolve)
        },
        {
            path: "/studentMain",
            name: "studentMain",
            component: resolve =>
                require([
                    "../views/productBoard/student/studentMain.vue"
                ], resolve)
        },
        {
            path: "/intelligentMain",
            name: "intelligentMain",
            component: resolve =>
                require([
                    "../views/productBoard/PC/intelligentMain.vue"
                ], resolve)
        },
        {
            path: "/prepareMain",
            name: "prepareMain",
            component: resolve =>
                require([
                    "../views/productBoard/prepareClass/prepareMain.vue"
                ], resolve)
        },
        {
            path: "/moveTeaMain",
            name: "moveTeaMain",
            component: resolve =>
                require([
                    "../views/productBoard/mobileTeach/moveTeaMain.vue"
                ], resolve)
        },
        //智慧课堂
        {
            path: "/wisdomClassMain",
            name: "wisdomClassMain",
            component: resolve =>
                require([
                    "../views/wisdomClass/wisdomClassMain.vue"
                ], resolve)
        },
        {
            path: "/homeworkDetails",
            name: "homeworkDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/homeworkDetails.vue"
                ], resolve)
        },
        {
            path: "/schoolUseProDetails",
            name: "schoolUseProDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/schoolUseProDetails.vue"
                ], resolve)
        },
        {
            path: "/teaUserScreenDetails",
            name: "teaUserScreenDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/teaUserScreenDetails.vue"
                ], resolve)
        },
        {
            path: "/teaUseProduct",
            name: "teaUseProduct",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/teaUseProduct.vue"
                ], resolve)
        },
        {
            path: "/assHomeworkTea",
            name: "assHomeworkTea",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/assHomeworkTea.vue"
                ], resolve)
        },
        {
            path: "/dataDetailsTab",
            name: "dataDetailsTab",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/dataDetailsTab.vue"
                ], resolve)
        },
        {
            path: "/schUseProDetails",
            name: "schUseProDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/schUseProDetails.vue"
                ], resolve)
        },
        {
            path: "/proUseDetails",
            name: "proUseDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/proUseDetails.vue"
                ], resolve)
        },
        {
            path: "/activeStudentDetails",
            name: "activeStudentDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/activeStudentDetails.vue"
                ], resolve)
        },
        {
            path: "/activeTeaTopDetails",
            name: "activeTeaTopDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/activeTeaTopDetails.vue"
                ], resolve)
        },
        {
            path: "/activeTeaDetails",
            name: "activeTeaDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/activeTeaDetails.vue"
                ], resolve)
        },
        {
            path: "/scrUserDetai",
            name: "scrUserDetai",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/scrUserDetai.vue"
                ], resolve)
        },
        {
            path: "/screenDistriDetails",
            name: "screenDistriDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/screenDistriDetails.vue"
                ], resolve)
        },
        {
            path: "/useProRateDetails",
            name: "useProRateDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/useProRateDetails.vue"
                ], resolve)
        },
        {
            path: "/resourceDetails",
            name: "resourceDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/resourceDetails.vue"
                ], resolve)
        },
        {
            path: "/microdetails",
            name: "microDetails",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/microDetails.vue"
                ], resolve)
        },
        {
            path: "/userdetailrecord",
            name: "userdetailrecord",
            component: resolve =>
                require([
                    "../views/schoolBoard/userDetails/detailsModules/userDetailRecord.vue"
                ], resolve)
        },
        ]
    },
    {
        path: "/wisdomclassmap",
        name: "wisdomclassmap",
        component: resolve =>
            require([
                "../views/wisdomClass/map/main.vue"
            ], resolve)
    },
    // 为了兼容已存书签的地址，暂时保留当前错误路径
    {
        path: "/databorad/:schoolCode",
        name: "databorad",
        component: resolve =>
            require(["../views/dashboard/index.vue"], resolve)
    },
    {
        path: "/databoard/:schoolCode",
        name: "databoard",
        component: resolve =>
            require(["../views/dashboard/index.vue"], resolve)
    },
    // 为了兼容已存书签的地址，暂时保留当前错误路径
    {
        path: "/schooldataborad/:schoolId",
        name: "schooldataborad",
        component: resolve =>
            require(["../views/dashboard/schoolIndex.vue"], resolve)
    },
    {
        path: "/schooldataboard/:schoolId",
        name: "schooldataboard",
        component: resolve =>
            require(["../views/dashboard/schoolIndex.vue"], resolve)
    },
    {
        path: "/school",
        name: "school",
        component: resolve =>
            require(["../views/dashboard/pointSchoolIndex.vue"], resolve)
    },
    // 为了兼容已存书签的地址，暂时保留当前错误路径
    {
        path: "/cloudschooldataborad/:schoolId",
        name: "cloudschooldataborad",
        component: resolve =>
            require(["../views/dashboard/cloudSchoolIndex.vue"], resolve)
    },
    {
        path: "/cloudschooldataboard/:schoolId",
        name: "cloudschooldataboard",
        component: resolve =>
            require(["../views/dashboard/cloudSchoolIndex.vue"], resolve)
    },
    //南京金陵微校数据展板
    {
        path: "/njschooldataboard",
        name: "njschooldataboard",
        component: resolve =>
            require(["../views/disMap/disStaticsSuper.vue"], resolve)
    },
    {
        path: "/dischooldataboard",
        name: "dischooldataboard",
        component: resolve =>
            require(["../views/disMap/disStaticsSuper.vue"], resolve)
    },
    //贵州省数据展板
    //         {
    //             path: "/gzschooldataboard",
    //             name: "gzschooldataboard",
    //             component: resolve =>
    //                 require(["../views/guizhouMap/gzStaticsSuper.vue"], resolve)
    //         },
    //云南普洱市数据展板
    {
        path: "/puerschooldataboard",
        name: "puerschooldataboard",
        component: resolve =>
            require(["../views/puerMap/puErStaticsSuper.vue"], resolve)
    },
    //区域数据展板
    {
        path: "/areaschooldataboard",
        name: "areaschooldataboard",
        component: resolve =>
            require(["../views/areaschooldataboard/index.vue"], resolve)
    },
    {
        path: "/syareadataboard",
        name: "syareadataboard",
        component: resolve =>
            require(["../views/site/syAreaDataboard.vue"], resolve)
    },
    {
        path: "/xgareadataboard",
        name: "xgareadataboard",
        component: resolve =>
            require(["../views/site/xgAreaDataboard.vue"], resolve)
    }, {
        path: "/qxareadataboard",
        name: "qxareadataboard",
        component: resolve =>
            require(["../views/site/qxAreaDataboard.vue"], resolve)
    },
    // 为了兼容已存书签的地址，暂时保留当前错误路径
    {
        path: "/regiondataborad",
        name: "regiondataborad",
        component: resolve =>
            require(["../views/dashboard/regionIndex.vue"], resolve)
    },
    {
        path: "/regiondataboard",
        name: "regiondataboard",
        component: resolve =>
            require(["../views/dashboard/regionIndex.vue"], resolve)
    },
    {
        path: "/tableMain",
        name: "tableMain",
        component: resolve =>
            require(["../views/dashboard/table/tableMain.vue"], resolve),
        children: [{
            path: "/classList/:schoolCode/:schoolId/:schoolName",
            name: "classList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/classList.vue"
                ], resolve)
        },
        {
            path: "/schoolClassList/:schoolId/:schoolName",
            name: "schoolClassList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/schoolClassList.vue"
                ], resolve)
        },
        {
            path: "/teacherList/:schoolCode/:schoolId/:schoolName",
            name: "teacherList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/teacherList.vue"
                ], resolve)
        },
        {
            path: "/schoolStudentList/:schoolId/:schoolName",
            name: "schoolStudentList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/schoolStudentList.vue"
                ], resolve)
        },
        {
            path: "/schoolTeacherList/:schoolId/:schoolName",
            name: "schoolTeacherList",
            meta: {
                keepAlive: true
            },
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/schoolTeacherList.vue"
                ], resolve)
        },
        {
            path: "/studentList/:schoolCode/:schoolId/:schoolName",
            name: "studentList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/studentList.vue"
                ], resolve)
        },
        {
            path: "/resourceList/:schoolCode/:schoolId/:schoolName",
            name: "resourceList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/resourceList.vue"
                ], resolve)
        },
        {
            path: "/homeworkList/:schoolCode/:schoolId/:schoolName",
            name: "homeworkList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/homeworkList.vue"
                ], resolve)
        },
        {
            path: "/classInterList/:schoolCode/:schoolId/:schoolName",
            name: "classInterList",
            component: resolve =>
                require([
                    "../views/dashboard/table/baseData/classInterList.vue"
                ], resolve)
        },
        {
            path: "/newDataList/:schoolCode/:schoolId/:schoolName/:tabsName",
            name: "newDataList",
            component: resolve =>
                require([
                    "../views/dashboard/table/dataDetails/newDataList.vue"
                ], resolve)
        },
        {
            path: "/schoolNewDataList/:schoolId/:schoolName/:tabsName/:filtersName/:classId/:gradeId/:subjectId/:teaId",
            name: "schoolNewDataList",
            component: resolve =>
                require([
                    "../views/dashboard/table/dataDetails/schoolNewDataList.vue"
                ], resolve)
        },
        {
            path: "/newSchoolDataDetails",
            name: "newSchoolDataDetails",
            component: resolve =>
                require([
                    "../views/dashboard/table/dataDetails/newSchoolDataDetails.vue"
                ], resolve)
        },
        {
            path: "/actstatisdetails",
            name: "actstatisdetails",
            component: resolve =>
                require(["../views/dashboard/table/dataDetails/actStatisDetails.vue"], resolve)
        },
        {
            path: "/regionstatisdetails",
            name: "regionstatisdetails",
            component: resolve =>
                require(["../views/dashboard/table/dataDetails/regionStatisDetails.vue"], resolve)
        },
        {
            path: "/regiondatalist",
            name: "regiondatalist",
            component: resolve =>
                require(["../views/dashboard/table/dataDetails/regionDataList.vue"], resolve)
        },
        {
            path: "/teacheruserpro",
            name: "teacheruserpro",
            component: resolve =>
                require(["../views/dashboard/table/baseData/teacherUserPro.vue"], resolve)
        },
        {
            path: "/useractionanalyse",
            name: "useractionanalyse",
            meta: {
                keepAlive: true
            },
            component: resolve =>
                require(["../views/dashboard/modules/userActionAnalyse.vue"], resolve)
        },
        {
            path: "/regionuseractionanalyse",
            name: "regionuseractionanalyse",
            meta: {
                keepAlive: true
            },
            component: resolve =>
                require(["../views/dashboard/modules/regUserActionAnalyse.vue"], resolve)
        },
        {
            path: "/useractiondetails",
            name: "useractiondetails",
            component: resolve =>
                require(["../views/dashboard/modules/userActionDetails.vue"], resolve)
        },
        {
            path: "/answeranalylist",
            name: "answeranalylist",
            component: resolve =>
                require(["../views/dashboard/table/dataDetails/answerAnalyList.vue"], resolve)
        },
        {
            path: "/answeranalylistdetails",
            name: "answeranalylistdetails",
            component: resolve =>
                require(["../views/dashboard/table/dataDetails/answerAnalyListDetails.vue"], resolve)
        }
        ]
    },
    {
        path: "/map",
        name: "map",
        component: resolve =>
            require(["../views/map/index.vue"], resolve)
    },
    {
        path: "/fillReport/:workId",
        name: "fillReport",
        component: resolve =>
            require([
                "../views/dashboard/table/cloudReport/fillReport.vue"
            ], resolve)
    },
    {
        path: "/objectReport/:workId",
        name: "objectReport",
        component: resolve =>
            require([
                "../views/dashboard/table/cloudReport/objectReport.vue"
            ], resolve)
    },
    {
        path: "/subjectReport/:workId",
        name: "subjectReport",
        component: resolve =>
            require([
                "../views/dashboard/table/cloudReport/subjectReport.vue"
            ], resolve)
    },
    {
        path: '/freelogin',
        name: 'freelogin',
        component: resolve =>
            require(["../views/freeLogin.vue"], resolve)
    },
    {
        path: '/homework',
        name: 'homework',
        component: resolve =>
            require(["../views/productBoard/homework/statisMain.vue"], resolve),
        redirect: 'noredirect',
        children: [{
            path: "teacherstatic",
            name: "teacherstatic",
            component: resolve =>
                require(["../views/productBoard/homework/teacherStatis.vue"], resolve)
        },
        {
            path: "classstatic",
            name: "classstatic",
            component: resolve =>
                require(["../views/productBoard/homework/classStatis.vue"], resolve)
        },
        {
            path: "gradestatic",
            name: "gradestatic",
            component: resolve =>
                require(["../views/productBoard/homework/gradeStatis.vue"], resolve)
        }
        ]
    },
    {
        path: '/qxdataboard',
        name: 'qxdataboard',
        component: resolve => require(["../views/areaschooldataboard/qxDataBorad.vue"], resolve)
    },
    {
        path: '/qingxudataboard',
        name: 'qingxudataboard',
        component: resolve => require(["../views/areaschooldataboard/qingxuDataBorad.vue"], resolve)
    },
    {
        path: '/sydataboard',
        name: 'sydataboard',
        component: resolve => require(["../views/sydataboard/index.vue"], resolve)
    },
    {
        path: '/regionpanoramaboard',
        name: 'regionpanoramaboard',
        component: resolve => require(["../views/site/region/index.vue"], resolve),
        redirect: "/panorama",
        children: [{
            path: "/panorama",
            name: "panorama",
            component: resolve =>
                require(["../views/site/region/panorama.vue"], resolve)
        },
        {
            path: "/teaching",
            name: "teaching",
            component: resolve =>
                require(["../views/site/region/teaching.vue"], resolve)
        },
        {
            path: "/resource",
            name: "resource",
            component: resolve =>
                require(["../views/site/region/resource.vue"], resolve)
        },
        {
            path: "/regionresearch",
            name: "regionresearch",
            component: resolve =>
                require(["../views/site/region/teach.vue"], resolve)
        },
        {
            path: "/regionteach",
            name: "regionteach",
            component: resolve =>
                require(["../views/areaschooldataboard/index.vue"], resolve)
        }
        ]
    },
    {
        path: '/schoolpanoramaboard',
        name: 'schoolpanoramaboard',
        component: resolve => require(["../views/site/school/index.vue"], resolve),
        redirect: "/schoolresearch",
        children: [{
            path: "/schoolresearch",
            name: "schoolresearch",
            component: resolve =>
                require(["../views/site/school/teach.vue"], resolve)
        },
        {
            path: "/schoolresource",
            name: "schoolresource",
            component: resolve =>
                require(["../views/site/region/resource.vue"], resolve)
        },
        {
            path: "/schoolteaching/:id",
            name: "schoolteaching",
            component: resolve =>
                require(["../views/dashboard/schoolIndex.vue"], resolve)
        },
        ]
    },
    {
        path: '/gxdataboard',
        name: 'gxdataboard',
        component: resolve => require(["../views/gxdataboard/index.vue"], resolve),
    },
    {
        path: '/hsdataboard',
        name: 'hsdataboard',
        component: resolve => require(["../views/gxdataboard/index.vue"], resolve),
    },
    // 南京数据展板
    {
        path: '/nanjingdataboard',
        name: 'nanjingdataboard',
        component: resolve => require(["../views/nanjingdataboard/index.vue"], resolve),
    },
    //无权限页面
    {
        path: '/errorpage',
        name: 'errorpage',
        component: resolve => require(["../views/errorPage.vue"], resolve),
    },
    {
        path: "/studentpad",
        name: "studentpad",
        component: resolve =>
            require(["../views/studentPad/index.vue"], resolve)
    },
    ]
});

// 白名单路由
const whiteList = ['/databorad', '/databoard', 'fillReport', 'objectReport', 'subjectReport', '/freelogin', '/wisdomClassMain', 'njschooldataboard', 'dischooldataboard', 'puerschooldataboard', 'syareadataboard', 'xgareadataboard', 'qxareadataboard', 'school', 'download', 'areaschooldataboard', '/qxdataboard', '/qingxudataboard', '/regionpanoramaboard', '/panorama', '/resource', '/teaching', '/regionteach', '/schoolpanoramaboard', '/schoolresearch', '/schoolresource', "/regionresearch",
    "/gxdataboard", "/hsdataboard", "/schooldataboard/5ee5b923177a45aeb8133caaed684003", "/schoolteaching/5ee5b923177a45aeb8133caaed684003", "/schooldataboard/zbzqao6l35hdtwjut9hmmg", '/errorpage'
];
let isProduction = process.env.NODE_ENV === 'production' || process.env.VUE_APP_APIURL == 'https://service.iclass30.com';
if (isProduction) {
    router.beforeEach((to, from, next) => {
        if (utils.versions().mobile) {
            location.href = "/mobile/"; //配置跳转手机端地址
            next(false);
        }
        if (whiteList.indexOf(to.path) !== -1 || whiteList.indexOf(to.name) !== -1) {
            // 当path在免登录白名单时，直接进入
            // 如果带了 token，异步获取用户信息以提取学段 phase（不阻塞页面加载）
            let whiteToken = to.query.token;
            if (whiteToken && !store.getters.phase) {
                store.dispatch('getUserInfo', { token: whiteToken }).then(() => {}).catch(() => {});
            }
            next();
        } else {
            let queryToken = to.query.token;
            if (queryToken) {
                store.commit('SET_TOKEN', queryToken);
                let userParam = {};
                userParam.token = queryToken;
                store.dispatch('getUserInfo', userParam).then(res => {
                    //如果用户为代理商则获取代理商id
                    console.log("res", res)
                    if (res.user_type == 4) {
                        store.dispatch('findAgentInfoByUserId', {
                            userId: res.id
                        }).then(() => {
                            //判断admin_type是否为系统管理员和校管理员
                            // admin_type==1:总管理 admin_type == 2:校管  user_type:4:代理商  user_type：5：运营
                            if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5 || res.user_type == 6) {
                                if (to.path === '/schoolList') {
                                    if (res.admin_type == 2) {
                                        // 校管跳转至学校页面
                                        next({
                                            path: '/schoolMain'
                                        });
                                    } else {
                                        next();
                                    }
                                } else {
                                    next();
                                }
                            } else {
                                Message.error('抱歉,您暂无权限登录该系统！');
                                ssoClient.logout(process.env.VUE_APP_DOMAIN + '/errorpage');
                            }
                        }).catch(res => { });
                    } else {
                        //判断admin_type是否为系统管理员和校管理员
                        // admin_type==1:总管理 admin_type == 2:校管  user_type:4:代理商  user_type：5：运营
                        if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5 || res.user_type == 6) {
                            if (to.path === '/schoolList') {
                                if (res.admin_type == 2) {
                                    // 校管跳转至学校页面
                                    next({
                                        path: '/schoolMain'
                                    });
                                } else {
                                    next();
                                }
                            } else {
                                next();
                            }
                        } else {
                            Message.error('抱歉，您暂无权限登录该系统！');
                            ssoClient.logout(process.env.VUE_APP_DOMAIN + '/errorpage');
                        }
                    }
                }).catch(() => {
                    store.dispatch('LogOut').then(() => { });
                });
            } else {
                ssoClient.check(process.env.VUE_APP_APPID, false);
                let token = ssoClient.getCookie() || store.getters.token;
                if (token) {
                    // let userParam = {
                    //     userId: to.path == '/areaschooldataboard' ? to.query.userId : (ssoClient.userInfo.id || store.getters.userId)
                    // };
                    let userParam = {};
                    if (token) {
                        userParam.token = token;
                    } else {
                        userParam.userId = to.path == '/areaschooldataboard' ? to.query.userId : (ssoClient.userInfo.id || store.getters.userId)
                    }
                    store.dispatch('getUserInfo', userParam).then(res => {
                        //如果用户为代理商则获取代理商id
                        console.log("res", res)
                        if (res.user_type == 4) {
                            store.dispatch('findAgentInfoByUserId', {
                                userId: res.id
                            }).then(() => {
                                //判断admin_type是否为系统管理员和校管理员
                                // admin_type==1:总管理 admin_type == 2:校管  user_type:4:代理商  user_type：5：运营
                                if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5 || res.user_type == 6) {
                                    if (to.path === '/schoolList') {
                                        if (res.admin_type == 2) {
                                            // 校管跳转至学校页面
                                            next({
                                                path: '/schoolMain'
                                            });
                                        } else {
                                            next();
                                        }
                                    } else {
                                        next();
                                    }
                                } else {
                                    Message.error('抱歉,您暂无权限登录该系统！');
                                    ssoClient.logout(process.env.VUE_APP_DOMAIN + '/errorpage');
                                }
                            }).catch(res => { });
                        } else {
                            //判断admin_type是否为系统管理员和校管理员
                            // admin_type==1:总管理 admin_type == 2:校管  user_type:4:代理商  user_type：5：运营
                            if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5 || res.user_type == 6) {
                                if (to.path === '/schoolList') {
                                    if (res.admin_type == 2) {
                                        // 校管跳转至学校页面
                                        next({
                                            path: '/schoolMain'
                                        });
                                    } else {
                                        next();
                                    }
                                } else {
                                    next();
                                }
                            } else {
                                Message.error('抱歉，您暂无权限登录该系统！');
                                ssoClient.logout(process.env.VUE_APP_DOMAIN + '/errorpage');
                            }
                        }
                    }).catch(() => {
                        store.dispatch('LogOut').then(() => { });
                    });
                } else {
                    // 否则全部重定向到登录页
                    ssoClient.login(
                        process.env.VUE_APP_APPID
                    );
                }
                return
            }
        }
    });
} else {
    router.beforeEach((to, from, next) => {
        if (utils.versions().mobile) {
            location.href = "/mobile/"; //配置跳转手机端地址
            next(false);
        }
        if (whiteList.indexOf(to.path) !== -1 || whiteList.indexOf(to.name) !== -1) {
            // 当path在免登录白名单时，直接进入
            // 如果带了 token，异步获取用户信息以提取学段 phase（不阻塞页面加载）
            let whiteToken = to.query.token;
            if (whiteToken && !store.getters.phase) {
                store.dispatch('getUserInfo', { token: whiteToken }).then(() => {}).catch(() => {});
            }
            next();
        } else {
            let queryToken = to.query.token;
            if (queryToken) {
                store.commit('SET_TOKEN', queryToken);
            }
            ssoClient.check(process.env.VUE_APP_APPID, false);
            let token = queryToken || ssoClient.getCookie() || store.getters.token;
            let userid = ssoClient.userInfo.id || store.getters.userId || utils.getQueryString("userId");
            console.log(token)
            if (token || userid) {
                // let userParam = {
                //     userId: to.path == '/areaschooldataboard' ? to.query.userId : userid
                // };
                let userParam = {};
                if (token) {
                    userParam.token = token;
                } else {
                    userParam.userId = to.path == '/areaschooldataboard' ? to.query.userId : userid;
                }
                store.dispatch('getUserInfo', userParam).then(res => {
                    //如果用户为代理商则获取代理商id
                    console.log(res)
                    if (res.user_type == 4) {
                        store.dispatch('findAgentInfoByUserId', {
                            userId: res.id
                        }).then(() => {
                            //判断admin_type是否为系统管理员和校管理员
                            // admin_type==1:总管理 admin_type == 2:校管  user_type:4:代理商  user_type：5：运营
                            if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5 || res.user_type == 6) {
                                if (to.path === '/schoolList') {
                                    if (res.admin_type == 2) {
                                        // 校管跳转至学校页面
                                        next({
                                            path: '/schoolMain'
                                        });
                                    } else {
                                        next();
                                    }
                                } else {
                                    next();
                                }
                            } else {
                                Message.error('抱歉,您暂无权限登录该系统！');
                                ssoClient.logout(process.env.VUE_APP_DOMAIN + '/errorpage');
                            }
                        }).catch(res => { });
                    } else {
                        //判断admin_type是否为系统管理员和校管理员
                        // admin_type==1:总管理 admin_type == 2:校管  user_type:4:代理商  user_type：5：运营
                        if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5 || res.user_type == 6 || res.user_type == 1) {
                            if (to.path === '/schoolList') {
                                if (res.admin_type == 2) {
                                    // 校管跳转至学校页面
                                    next({
                                        path: '/schoolMain'
                                    });
                                } else {
                                    next();
                                }
                            } else {
                                next();
                            }
                        } else {
                            Message.error('抱歉，您暂无权限登录该系统！');
                            ssoClient.logout(process.env.VUE_APP_DOMAIN + '/errorpage');
                        }
                    }
                }).catch(() => {
                    store.dispatch('LogOut').then(() => { });
                });
            } else {
                // 否则全部重定向到登录页
                ssoClient.login(
                    process.env.VUE_APP_APPID
                );
            }
            return
        }
    })
}
